import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = () => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [interest, setInterest] = useState('')
    const [message, setMessage] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()

        const serviceId = 'service_2kc4vzk';
        const templateId = 'template_mrb3r3t';
        const publicKey = 'g4MmXzjdf8CgxQWFe';

        const templateParams = {
            from_name: name,
            from_email: email,
            from_interest: interest,
            to_name: 'Aayush Srivastava',
            message: message,
        };

        
        emailjs.send(serviceId, templateId, templateParams, publicKey)
            .then((response) => {
                console.log('Email sent successfully!', response)
                toast.success('Message sent successfully!', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    })
                setName('')
                setEmail('')
                setInterest('')
                setMessage('')
            })
            .catch((error) => {
                console.error('Error sending email:', error)
                toast.error('Failed to send the message.', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    })
            })
    }

    return (
        <>
        <form onSubmit={handleSubmit} className='pt-5 ps-3 pe-3 pb-3'>
            <div className="mb-3 text-start row">
                <div className='col'>
                <label for="name" className="form-label text-body-tertiary fs-5 fw-bolder">Your Name*</label>
                <input 
                    type="name" 
                    className="form-control" 
                    id="name" 
                    placeholder='Ex. John Doe' 
                    value={name} 
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                </div>
                <div className='col'>
                <label for="email" className="form-label text-body-tertiary fs-5 fw-bolder">Email*</label>
                <input 
                    type="email" 
                    className="form-control" 
                    id="email" 
                    aria-describedby="emailHelp" 
                    placeholder='example@gmail.com'
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                </div>
            </div>
            <div className="mb-3 text-start row">
                <div className='col'>
                <label for="subject" className="form-label text-body-tertiary fs-5 fw-bolder">I'm Interested in*</label>
                <select 
                    type="subject" 
                    className="form-select" 
                    id="subject"
                    value={interest} 
                    onChange={(e) => setInterest(e.target.value)}
                    required
                >
                    <option value="" selected>Select</option>
                    <option value="mentorship">Mentorship</option>
                    <option value="advice">Advice</option>
                    <option value="other">Other</option>
                </select>
                </div>
            </div>
            <div className="mb-3 text-start row">
                <div className='col'>
                <label for="exampleFormControlTextarea1" className="form-label text-body-tertiary fs-5 fw-bolder">Your Message*</label>
                <textarea 
                    className="form-control" 
                    id="exampleFormControlTextarea1" 
                    rows="3"
                    value={message} 
                    onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                </div>
            </div>
            <div className='text-start pt-2'>
                <button type="submit" className="btn btn-primary fw-medium rounded-5">Send Message &rarr;</button>
            </div>
        </form>
        <ToastContainer />
        </>
    )
}

export default ContactForm